import { render, staticRenderFns } from "./CostumeInventory.vue?vue&type=template&id=3ee37e33"
import script from "./CostumeInventory.vue?vue&type=script&lang=js"
export * from "./CostumeInventory.vue?vue&type=script&lang=js"
import style0 from "./CostumeInventory.vue?vue&type=style&index=0&id=3ee37e33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports